export const SET_RESOLUTION = 1;
export const SET_SEQUENCER_ENGINE = 2;
export const SET_VIEW_MODE = 3;
export const SET_DETAILS_VIEW = 4;
export const SET_DECENTRALIZED = 5;
export const SET_SELECTOR_MODE = 6;
export const SET_NUMBER_PATTERNS= 7;
export const SET_CURRENT_PATTERN = 8;
export const SET_CURRENT_STEP = 9;
export const SET_CURRENT_GLOBAL_STEP = 10;

export const SET_SAMPLE = 11;

export const START_TRIGGER_TRACK = 12;
export const STOP_TRIGGER_TRACK = 13;

export const TOGGLE_TRACK = 14;
export const UNTOGGLE_TRACK = 15;

export const SET_SAMPLE_PACK = 16;

export const ADD_SAMPLE_PACK = 17;
export const REMOVE_SAMPLE_PACK = 18;

export const DRAG_SAMPLE = 19;
export const DRAG_EFFECT = 20;
export const DRAG_PATTERN = 21;

// for when the user drags across steps to quickly toggle them,
// either true (the mouse is currently clicking and dragging) or
// false (the mouse is not clicking right now)
export const MOUSE_DOWN = 22;

// when MOUSE_DOWN is true, this is used to tell you whether it should
// toggle the step should toggle on or off
export const DRAG_TOGGLE = 23;
export const DRAG_STEP_TRANSPOSE = 24;

// true when the "command" key is held down, this mode allows
// people to drag the durations of steps
export const COMMAND_DOWN = 25;

export const TRACK_RECORDING = 26;
export const TRACK_PREPARING_TO_RECORD = 27;

export const SET_TRACK_STEPS = 28;
export const UPDATE_STEPS_FOR_ALL_TRACKS = 29;
export const SET_ALL_TRACK_STEPS = 30;
export const SET_TRACK_FILLS = 31;
export const SET_TRACK_PIANO_ROLL_STEPS = 32;

export const SET_SELECTED_TRACK = 33;
export const SET_SELECTED_GROUP = 34;

export const SET_TRACK_VOLUME = 35;
export const SET_TRACK_MUTED = 36;
export const SET_TRACK_SOLO = 37;

export const SET_GROUP_VOLUME = 38;
export const SET_GROUP_MUTED = 39;

export const SET_QUANTIZED = 40;
export const SET_IS_RECORDING = 41;
export const SET_IS_RECORDING_EXPANDED  = 42;
export const SET_IS_RECORDING_MIX = 43;
export const SET_IS_PLAYING = 44; 
export const SET_IS_PLAYING_MIX = 45;

export const SET_SEND_MUTED = 46;

export const SET_SELECTED_STEP = 47;
export const SET_HOVERED_STEP = 48;

export const SET_STEP_DRAGGING = 49;
export const SET_STEP_TO_COPY = 50;

export const SET_SEQUENCE_NAME = 51;

export const SET_SELECTED_EFFECT = 52;

export const SET_EFFECT_PARAMETER_VALUE = 53;

export const SET_EFFECTS_PANE_OPTION = 54;

export const SET_SELECTED_PARAMETER = 55;
export const SET_SELECTED_PARAMETER_FLASHING = 56;

export const SET_MIXES = 57;
export const SET_CURRENT_MIX = 58;

export const SET_ERASING_AUTOMATION = 59;

export const SET_TRACK_SEND_VOLUME = 60;

export const SET_TRACK_FOCUSED = 61;

export const SET_YEAR_SELECTED = 62;
export const SET_COUNTRIES_SELECTED = 63;
export const SET_VIDEOS_SELECTED = 64;
export const SET_STYLES_SELECTED = 65;
export const SET_TAGS_SELECTED = 66;
export const SET_HIERARCHY_ROOT = 67;
export const SET_HIERARCHY_TREE = 68;
export const SET_SHOW_YEAR_SLIDER = 69;
export const SET_SHOW_COUNTRIES = 70;
export const SET_SHOW_VIDEOS = 71;
export const SET_SHOW_STYLES = 72;
export const SET_SHOW_TAGS = 73;
export const SET_SHOW_CHORD_FILTER = 74;
export const SET_CHORD_SELECTED = 75;

export const SET_IS_DRAGGING_DURATION = 76;
export const SET_STEP_DATA_DRAGGING = 77;

export const SET_PIANO_ROLL_SELECTION = 78;
export const SET_SELECTED_PIANO_ROLL_STEPS  = 79;

export const SET_SEARCH_RESULTS_SAMPLES = 80;

export const SET_SELECTED_CHORD_SAMPLE = 81;

export const SET_STEPS_TO_COPY = 82;

export const SET_LOADING_SEQUENCE = 83;

export const SET_EASY_PATTERN_TO_COPY = 84;

export const SET_SAMPLE_AUDITIONING = 85;

export const SET_LAST_MIDI_KEY_MAPPED = 86;

export const SET_TRACK_IS_ENABLED = 87;

export const SET_SELECTED_SAMPLE_TAG = 88;

export const SET_TRANSPOSE_DRAGGING = 89;

export const SET_MASTER_VOLUME = 90;

export const SET_USER_VIEW_MODE = 91;

export const SET_CURRENT_USER_MIX = 92;

export const SET_USER_HAS_EDITS_TO_SAVE = 93;

export const SET_PATTERN_TO_EDIT_COLOR = 94;
export const SET_PATTERN_COLOR = 95;

export const SET_COMPACT_MODE = 96;

export const SET_SHOW_LFOS = 97;

export const SET_TRACKS_TO_RESAMPLE = 98;

export const SET_PROJECT_AUTOMATION_MODE = 99;

export const NEW_SEQUENCE = 100;

export const SET_STEPS_SELECTION = 101;
export const SET_SELECTED_STEPS = 102;
export const SET_STEP_NUMBER_DRAGGING_FROM = 103;

export const SET_ALL_TRACK_PATTERN_LOCKS = 104;
export const SET_ALL_ENVELOPE_LOCKS = 105;
export const SET_ALL_LFO_LOCKS = 106;
export const SET_TRACK_PATTERN_LOCKED = 107;
export const SET_TRACK_PATTERN_LOCKS = 108;
export const SET_LFO_PATTERN_LOCKS = 109;
export const SET_ENVELOPE_PATTERN_LOCKS = 110;
export const SET_PIANO_ROLL_PAGINATION = 111;

export const SET_IS_RESAMPLING = 112;

export const SET_RESAMPLE_DURATION = 113;

export const SET_KEY_MAPPINGS = 114;

export const SET_SHOW_SEQUENCE_MODAL = 115;

export const SET_MULTI_PARAMETER_SLIDER = 116;

export const SET_SHOW_MODS_MODAL = 117;

export const SET_SEQUENCE_ROLLING = 118;

export const SET_TRACK_EFFECTS_CHAIN = 119;

export const SET_SHOW_SEQUENCES = 120;
export const SET_SHOW_PRESETS = 121;
export const SET_SHOW_INSTRUMENTS = 122;

export const SET_TRACK_ROLLING = 123;

export const SET_Z_INDEX_HACK = 124;

export const SET_LOADED_TRACKS = 125;

export const SET_BPM = 126;

export const SET_RESAMPLE_MASTER = 127;

export const SET_YOUTUBE_SEARCH_TERMS = 128;

export const SET_AUDIO_INPUT_SOURCE = 129;

export const SET_WAVEFORM_SELECTION = 130;

export const SET_WAVEFORM_SELECTION_END = 131;

export const SET_MIDI_MAP_MODE = 132;
export const SET_PARAMETER_MIDI_MAP_SELECTION = 133;
export const SET_PARAMETER_MIDI_MAPPING = 134;
export const DELETE_PARAMETER_MIDI_MAPPING = 135;

export const SET_LATENCY = 136;

export const SET_PAD_MAPPINGS = 137;

export const SET_ACTION_MIDI_MAP_SELECTION = 138;
export const SET_ACTION_MIDI_MAPPING = 139;
export const DELETE_MIDI_MAPPINGS = 140;

export const SET_SEQUENCE_PATTERN_LOCKED = 141;
export const SET_SEQUENCE_PATTERN_LOCKS = 142;

export const SET_SPOTLIGHT_TRACKS = 143;

export const SET_CLOCK_TYPE = 144;

export const SET_CONNECTION_STATUS = 145;
export const SET_CONNECTED_USER_NAME = 146;
export const SET_CLOCK_TICK = 147;
export const SET_PLAY_SCHEDULED = 148;
export const SET_AVAILABLE_USERS_TO_SYNC = 149;

export const SET_SEARCH_SORT_BY = 150;

export const SET_MIDI_EFFECT_DRAGGING = 151;

export const SET_SHOW_TRACK_EFFECTS = 152;

export const SET_SHOW_CONVOLVER_MODAL = 153;

export const SET_SHOW_PASSWORD_MODAL = 154;
export const SET_PASSWORD_MODAL_CALLBACK = 155;

export const SET_SHOW_SHARE_SEQUENCE_MODAL = 156;

export const HIDE_ALL_EFFECTS = 157;

export const SET_SHOW_ENVELOPES = 158;

export const SET_EFFECT_COLLAPSED = 159;

export const SET_CONTEXTUAL_HELP = 160;

export const SET_SELECTED_LFO = 161;
export const SET_SELECTED_ENVELOPE= 162;

export const SET_SIDEBAR_COLLAPSED = 163;

export const SET_MIX_EVENTS = 164;

export const SET_SHOW_GROUPS = 165;

export const SET_SUB_SEQUENCES = 166;
export const SET_CURRENT_SUB_SEQUENCE = 167;

export const SET_MIX_VIEW_MODE = 168;

export const SET_SUB_SEQUENCE_FADE = 169;

export const SET_SAMPLE_SLICES = 170;

export const SET_SELECTED_ARRANGEMENT_EVENTS = 171;

export const SET_SHOW_DATE_SAMPLED = 172;
export const SET_DATE_SAMPLED = 173;

export const SET_EFFECT_PARAMETER_VALUES = 174;

export const SET_TRACK_PANNING = 175;
export const SET_GROUP_PANNING = 176;
export const SET_SEND_PANNING = 177;

export const SET_SELECTED_RECORD = 178;

export const SET_2D_SELECTION = 179;
export const SET_SIMILAR_SOUNDS_TO_FIND = 180;
export const SET_SHOW_SAMPLES_2D = 181;

export const SET_LAST_NOTE_PLAYED = 182;

export const SET_SIDEBAR_VIEW_MODE = 183;

export const SET_DISCOGS_SELECTED = 184;

export const SET_SELECTED_FOLDER = 185;
export const SET_SELECTED_PRESET = 186;
export const SET_HAS_CHANGES_TO_FOLDERS = 187;

export const SET_CURSOR_TRACK = 188;
export const SET_CURSOR_STEP = 189;
export const SET_CURSOR_SHOW = 190;

export const SET_FOLDER_DRAGGING = 191;
export const SET_PRESET_DRAGGING = 192;

export const SET_SAMPLE_DRAGGING = 193;

export const SET_EFFECTS_CHAIN_TO_SHOW = 194;
export const SET_SUB_SEQUENCE_MUTED = 195;

export const SET_TRACK_FROZEN = 196;
export const SET_TRACK_TO_FREEZE = 197;
export const SET_FROZEN_TRACK_PLAYING = 198;
export const SET_FROZEN_TRACKS = 199;
export const SET_FROZEN_TRACKS_PLAYING = 200;
export const SET_EFFECTS_CHAINS_TO_SHOW = 201;
export const SET_SELECTED_ONSETS = 202;
export const SET_SINGLE_STEP_TO_DRAG = 203;
export const SET_STEP_NUMBER_DRAGGED_TO = 204;

export const SET_SEARCH_RESULTS_START = 205;
export const SET_SHOW_STEP_OPTIONS = 206;

export const SET_MASTER_STEP_TOGGLES = 207;
export const SET_PARAMETERS_TO_RECORD = 208;
export const SET_ONSET_THRESHOLD = 209;
export const SET_SHOW_ONSETS = 210;

export const SET_SELECTED_GUILD = 211;
export const SET_CURRENT_AND_GLOBAL_STEPS = 212;

export const SET_PIANO_ROLL_DRAG_OFFSET= 213;
export const SET_PIANO_ROLL_NOTES = 214;
export const SET_STEP_AND_DATA_DRAGGING = 215;

export const SET_SHOW_LOGIN= 216;
export const SET_SIGNING_UP= 217;
export const SET_USER_TOKEN = 218;

export const SET_PENDING_TRANSACTIONS = 219;

export const SET_COMMAND_INPUT = 220;
export const SET_COMMAND_PREFIX = 221;
export const SET_VI_MODE = 222;
export const SET_TRACK_WARP = 223;
export const SET_SUB_SEQUENCE_WARPS = 224;

export const SET_ARRANGEMENT_SELECTION = 225;
export const SET_ARRANGEMENT_MOUSE_X = 226;
export const SELECT_COMPOUND_EVENT = 227;
export const UNSELECT_COMPOUND_EVENT = 228;

export const SET_ARRANGEMENT_AUTOMATION_TO_SHOW= 229;
export const SET_ARRANGEMENT_LOOPING = 230;

export const SET_ALTERNATE_VIEW_MODE = 231;
export const SET_ARRANGEMENT_SELECTED_ROWS = 232;
export const SET_ARRANGEMENT_LOOP_SELECTED = 233;
export const SET_ARRANGEMENT_ROW_SELECTIONS = 234;
export const SET_ARRANGEMENT_ZOOM = 235;

export const SET_SELECTED_SEQUENCE = 236;
export const SET_EXPLORE_MIXER_EFFECT = 237;
export const SET_EXPLORE_EQ_EFFECT = 238;
export const SET_SELECTED_SEND_EFFECT= 239;
export const SET_INSTRUMENT_TYPE_DRAGGING = 240;
export const SET_TRACK_IS_LOADING = 241;

export const SET_PIANO_ROLL_CURSOR = 242;
export const SET_ARRANGEMENT_X_SCALE = 243;
export const SET_TOTAL_ARRANGEMENT_LENGTH = 244;
export const SET_ARRANGEMENT_BOTTOM_HEIGHT = 245;
export const SET_ARRANGEMENT_BOTTOM_MODE = 246;
export const SET_ARRANGEMENT_BOTTOM_RESIZING = 247;
export const SET_ARRANGEMENT_PATTERN_DRAGGING = 248;
export const SET_ARRANGEMENT_PATTERN_START_STEP = 249;
export const SET_ARRANGEMENT_CURSOR_STEP = 250;
export const SET_ARRANGEMENT_PATTERN_RESIZING = 251;
export const SET_ARRANGEMENT_BROWSER_MODE = 252;
export const SET_SAMPLE_TO_EXPLORE = 253;
export const SET_EFFECT_RACK_NODE_POSITION = 254;

export const SET_ANNOTATION_DRAGGING = 255;

export const SET_TRACK_AUTOMATION_DEVICE = 256;
export const SET_TRACK_AUTOMATION_PARAMETER = 257;
export const SET_SHOW_AUTOMATION = 258;
export const SET_TRACK_AUTOMATION_SUB_DEVICE = 259;
export const SET_PARAMETER_AUTOMATIONS = 260;

export const SET_ACTIONS_REMAINING = 261;
export const SET_TIME_REMAINING = 262;

export const SET_SHOW_PIANO_ROLL = 263;

export const SET_SELECTED_RACK_SUB_TRACK= 264;

export const DELETE_AUTOMATIONS_FOR_PARAMETERS = 265;

export const SET_TRACK_AUTOMATION_RACK_DEVICE = 266;
export const SET_AUTOMATION_GUIDE_POINT = 267;
export const SET_AUTOMATION_POINT_DRAGGING  = 268;
export const SET_AUTOMATION_POINT_HAS_MOVED= 269;
export const SET_AUTOMATION_POINT_HOVERED = 270;

export const SET_TRACK_TO_CONVERT = 271;

export const SET_AUTOMATION_SELECTION = 272;
export const SET_AUTOMATION_POINTS_SELECTED = 273;

export const SET_EXPLORE_PERSON_SELECTED = 274;
export const SET_EXPLORE_ALL_SEQUENCES = 275;

export const DELETE_AUTOMATIONS_FOR_ENGINE = 276;

export const SET_RECORDING_EXPLORE_MIX = 277;

export const SET_WORKS_LOADED = 278;

export const SET_WORK_TRANSPOSE = 279;
export const SET_WORK_VOLUME = 280;

export const SET_EXPLORE_MIX_LOADED = 281;

export const SET_IS_MACRO_MAPPING = 282;

export const SET_PARAMETER_TO_MAP = 283;

export const SET_MIX_COLOR_VALUE = 284;

export const SET_MIX_HAS_EDITS = 285;
export const SET_SCRIPT_VARIABLES = 286;

export const SET_EXPLORE_OPTION = 287;

export const SET_ANNOTATIONS_VIEW = 288;

export const SET_EXPLORE_TOAST = 289;
export const SET_PARAMETER_SLIDER_DOWN = 290;

export const MOVE_ENGINE_AUTOMATIONS = 291;

export const SET_SEQUENCE_LOADING_PROGRESS = 292;

export const SET_TRACK_BROWSED_SAMPLES = 293;

export const SET_BOTTOM_TOOLBAR_OFFSET = 294;

export const SET_TRACK_UPDATES = 295;

export const SET_IS_TRANSCRIBING = 296;

export const SET_SAMPLE_TOOLTIP = 297;
export const SET_TRACK_BROWSED_PRESETS = 298;

export const SET_SELECTED_FREEZE = 299;

export const SET_TRACK_LENGTH_MODE = 300;
export const SET_TRACK_LENGTH_CHOICE = 301;
export const SET_FREEZE_DRAGGING = 302;
export const SET_FREEZE_COLUMN_SAMPLES = 303;
export const SET_UPLOADING_FILE = 304;
export const SET_GROUP_COLLAPSED = 305;

export const SET_SELECTED_MIX_EFFECT = 306;
export const SET_SAMPLES_DRAGGING = 307;

export const SET_DISPLAY_RESOLUTION = 308;

export const SET_OFFLINE_ENGINE = 309;

export const SET_CURRENT_EXPORT_INFO = 310;
export const SET_MIX_TRACK_DRAGGING = 311;
export const SET_GROUP_TRACKS = 312;

export const SET_LOADING_TEXT = 313;
export const SET_TRACK_ENVELOPES = 314;

export const SET_COPIED_NODES_FOR_RACK= 315;

export const SET_LAST_MIDI_CC_PLAYED = 316;

export const SET_ARRANGEMENT_MOUSE_DOWN_X = 317;

export const SET_TRACKER_PARAMETER_TO_EDIT = 318;

export const SET_TRACKS_TO_HIDE = 319;

export const SET_SELECTED_PALETTE = 320;

export const SET_PROJECT_DRAGGING = 321;

export const SET_EXPLORE_UNPUBLISHED = 322;
export const SET_QUICK_ADD_SEARCH_TEXT = 323;

export const SET_SHOW_TRACK_FREEZE_HISTORY = 324;
export const SET_SELECTED_MIDI_TRACK = 325;

export const SET_SELECTED_TRACK_SLICE = 326;

export const SET_CIRKLON_PARAMETER_SELECTED = 327;
export const SET_CIRKLON_MODE = 328;

export const SET_NOTES_DOWN = 329;
export const SET_SEQUENCED_PALETTE = 330;

export const SET_SCENES = 331;
export const SET_CURRENT_SCENE = 332;

export const SET_SHOW_SETTINGS = 333;
export const SET_WALLPAPER = 334;
export const SET_ANIMATE_WALLPAPER = 335;

export const SET_EXPANDED_PROJECT = 336;

export const SET_ACCUMULATOR_PARAMETER_SELECTED= 337;

export const SET_PLANE_MAPPING = 338;

export const SET_TRACK_PRESET_SAVING = 339;

export const SET_SAMPLE_TAG_DRAGGING = 340;

export const SET_PARAMETER_MIX_AUTOMATIONS = 341;

export const SET_SHOW_ARRANGEMENT_TRACKS= 342;

export const SET_ARRANGEMENT_PATTERN_SELECTED = 343;

export const SET_SIDEBAR_SEARCH_INPUT = 344;

export const SET_SHOW_ARRANGEMENT_SEARCHER = 345;

export const SET_VI_SELECT_MODE = 346;

export const SET_EXPLORE_WORK = 347;

export const SET_CREATING_NEW_PACK = 348;

export const SET_PACK_WINDOW_POSITION = 349;

export const SET_DRAGGING_PACK_WINDOW = 350;

export const SET_PACK_TO_EDIT = 351;

export const SET_IS_MANAGING_GUILDS= 352;

export const NEW_STEP_GROUP = 353;
export const SET_STEPS_GROUP_MODE = 354;

export const SET_TRANSFORMATION_EDGE_DRAGGING = 355;
export const SET_SHOW_FORMANT_EFFECT = 356;
export const SET_SHOWING_FORMANTS= 357;

export const SET_PULLED_EFFECTS = 358;

export const SET_LOOPS_TO_FREEZE = 359;
export const SET_PARAMETER_MIN_MAX = 360;

export const SET_CURRENT_SOUND_IN_LIST = 361;
export const SET_SHOWING_SOUND_LIST = 362;
export const SET_CURRENT_TAG_IN_LIST = 363;

export const SET_LINKING_EFFECTS = 364;
export const SET_PACK_SELECTED = 365;
export const SET_SAMPLE_EXPLORER_SELECTED = 366;

export const SET_PIANO_ROLL_SLIDE = 367;
export const SET_MAXIMIZE_EXPLORER = 368;

export const SET_PADS = 369;
export const SET_PAD_SLOTS = 370;

export const SET_PAD_HOVERED = 371;

export const SET_WAVEFORM_SHOWING = 372;
export const SET_TRACK_DRAGGING = 373;

export const SET_HIDE_MIXER = 374;

export const SET_SOURCE_EXPLORING = 375;
export const SET_YEAR_EXPLORING = 376;
export const SET_PULLABLE_PART_DRAGGING= 377;
export const SET_PADS_EXPAND = 378;

export const SET_SEQUENCERS = 379;
export const SET_SEQUENCER_TRACKS = 379;

export const SET_PLANE_MACROS = 380;
export const SET_WINDOW_POSITION = 381;
export const SET_PAD_EFFECTS = 382;
export const SET_SELECTED_PAD_EDGE = 383;
export const SET_DRAWING_PAD_EDGE = 384;
export const SET_BULK_EFFECTS_COLLAPSED = 385;
export const SET_SELECTED_PULLED_ELEMENTS= 386;
export const SET_BULK_WINDOW_POSITIONS = 387;
export const SET_EFFECT_PATTERN_LOCKS = 388;
export const SET_ALL_EFFECT_PATTERN_LOCKS = 389;
export const SET_MODULE_COLLAPSED = 390;
export const SET_TRACK_MIDI_EFFECTS = 391;
export const SET_EFFECT_STARRED= 392;
export const SET_BULK_EFFECTS_STARRED= 393;
export const SET_BULK_MODULES_COLLAPSED = 394;
export const DELETE_TRACK_ID = 395;
export const SET_SHOWING_CONTEXT_MENU = 396;
export const SET_HIGHER_ORDER_MATRIX= 397;
export const SET_MODULE_COLOR=398;
export const SET_MODULES_ROUTING =399;
export const SET_HIGHER_ORDER_STEPS_SELECTED=400;
export const SET_ORIENTATION_ROUTINGS=401;
export const SET_SHOW_HIGHER_ORDER_SEQUENCER=402;
export const SET_PLANAR = 403;

export const SET_PLANAR_GRADIENT_COLOR = 404;
export const SET_PLANAR_OPACITY = 405;

export const SET_MODULE_SIZE = 406;
export const SET_INLET_CONNECTIONS = 407;
export const SET_ZOBJECTS = 408;
export const SET_ZMESSAGES = 409;

export const SET_BACKGROUND_COLOR = 410;

export const SET_VIEWABLE_SUBPATCHES = 411;
export const SET_SELECTED_ZOBJECT = 412;

export const SET_JAKI_GRID = 413;

export const SET_ZOBJECT_TYPE_DRAGGING= 414;

export const SET_UX_LOCKED = 415;

export const SET_MINTED_TOKENS = 416;

export const SET_HIC_DIALOG = 417;
export const SET_IS_PREPARING_NFT = 418;
export const SET_FULL_SCREEN_ZOBJECT = 419;

export const SET_MAIN_SCROLL_REF= 420;
export const SET_VIEWPORT_POSITION = 421;
export const SET_SIDEBARS_SHOWING = 422;
export const SET_SHOW_PAD_SEQUENCER = 423;
export const SET_SHOW_PROJECTS_MODAL = 424;
export const SET_SHOW_SEARCH_WINDOW = 425;

export const SET_STEP_PARAMETER_SELECTED = 426;
export const SET_SHOW_TRACK_INSTRUMENT = 427;
export const SET_SHOW_MODULATORS = 428;

export const SET_CABLE_SEGMENTATION = 429;
export const SET_CABLE_SEGMENTATIONS = 430;

export const SET_UX_LOCK_OBJECT = 431;
export const SET_UX_LOCK_OBJECTS = 432;
export const SET_UX_HIDE_OBJECT = 433;
export const SET_UX_HIDE_OBJECTS = 434;
export const SET_ZORA_DIALOG = 445;
export const SET_ZOBJECT_INPUT_TEXT = 446;
export const SET_VIEWABLE_ZOBJECTS = 447;
export const SET_SHOW_EDITOR_BOTTOM = 448;

export const SET_MINTING_PROGRESS = 449;
export const SET_NEW_ZORA_TOKEN_ID = 450;
export const SET_TRANSACTION_UPON_LOGIN = 451;

export const SET_KEYBOARD_CONTEXT = 452;
export const SET_PAD_FX_MODE = 453;
export const SET_JAKI_GRID_MODE = 454;
export const SET_OBJECT_STYLING = 455;

// planar items

export const SET_SELECTED_PLANAR_PARAMETERS = 456;
export const SET_FILTERED_PLANAR_PARAMETERS = 457;
export const SET_PLANAR_MACRO_TO_SHOW = 458;
export const SET_PLANAR_REGION_MODE = 459;
export const SET_GROUP_PRESETS_BY_PACKS = 460;
export const SET_PIANO_ROLL_LEFT_SPACE = 461;
export const SET_ZOBJECT_SIZE = 462;
export const SET_SECONDARY_ZOBJECT = 463;

export const CLEAR_DRAG_DROP = 464;

export const SET_SAMPLES_TO_SAVE = 465;
export const SET_EDITOR_PADDING = 466;
export const SET_EDGES_PADDING = 467;
export const SET_EDGES_SIZE = 468;

export const SET_LEFT_SIDEBAR_WIDTH = 469;
export const SET_MOVING_PAD_EDGE = 470;
export const SET_DOCUMENTATION_SUB_SECTION = 471;
export const SET_RIGHT_SIDEBAR_OPTION = 472;

export const SET_SELECTED_FM_ENVELOPE_TYPE = 473;
export const SET_SELECTED_FM_OPERATOR_DETAILS = 474;
export const SET_SELECTED_FM_FORMANT = 475;
export const SET_SHOW_SAVE_MODAL = 476;
export const SET_ZOBJECT_FLASHING = 477;
export const SET_SAMPLE_DOWNLOAD_PROGRESS = 478;

export const SET_PRESET_SAVED = 479;

export const SET_COMPLETELY_DONE_LOADING = 480;
export const SET_PLUGIN_TO_SAVE = 481;
export const SET_SHOW_PLUGINS = 482;
export const SET_PLUGINS_LOADED = 483;
export const SET_SHOW_PLUGINS_PANE= 484;
export const SET_PLUGINS_PANE_HEIGHT = 485;
export const SET_DROPPED_SAMPLES = 486;
export const SET_SHOW_FORMANT_PRESETS = 487;
export const SET_ZOBJECT_BACKGROUND= 488;
export const SET_PRESENTATION_MODE = 489;


export const SET_PRESENTATION_WINDOW_POSITION = 490;
export const SET_BULK_PRESENTATION_WINDOW_POSITIONS = 491;

export const SET_SHOW_FREEZE_MODAL = 492;
export const SET_THEME = 493;
export const SET_SHOW_THEME_GRID = 494;

export const SET_RECENTLY_ADDED_SOUNDS = 495;

export const SET_ZOBJECT_TOOLTIP = 496;

export const SET_ZOBJECTS_STACK= 497;
export const SET_ZOBJECT_CONTEXT_MENU = 498;

export const SET_OBJECT_DRAGGING = 499;

export const SET_ENABLE_ROLL_VIEWER = 500;

export const SET_ZOBJECT_MODAL = 501;
export const SET_ZOBJECT_PROGRESSBAR = 502;
